
export default {
    namespaced: true,
    state: {   
        isLoading: false,
    },
    mutations: {
        changeLoadingState(state, isLoading) {
            state.isLoading = isLoading;
        }
    },
    getters: {
        isLoading(state) {
            return state.isLoading
        },

    },
    actions: {
        changeLoadingState({commit}, isLoading) {
            commit('changeLoadingState', isLoading)
        }
    }
}